import { IconName } from '@klp/design/Illustrations';
import { SidebarMenuItem } from '@klp/layout/Sidebar/classes/SidebarMenuItem';
import { generateRoute } from '@klpkonsern/routing';
import { getConfig } from '@klpkonsern/appconfig';
import type { Bruker } from '@klp/user';
export const ForvaltningsplanModuleName = 'forvaltningsplan';

export const ForvaltningsplanRoutes = {
    moduleRoute: () => generateRoute([ForvaltningsplanModuleName]),
};

export const ForvaltningsplanAccess = (user: Bruker | undefined): boolean =>
    Boolean(
        getConfig('WEBAPP_FORVALTNINGSPLAN_ENABLE') && user && user.isAdmin,
    );

export const ForvaltningsplanMenuItems = [
    new SidebarMenuItem({
        route: ForvaltningsplanRoutes.moduleRoute(),
        matchRoute: ForvaltningsplanRoutes.moduleRoute(),
        icon: IconName.DOC,
        translation: 'forvaltningsplan.title',
        access: ForvaltningsplanAccess,
    }),
];

export const configApiName = 'config';
export const forvaltningsplanApiName = 'confluence';
export const confluenceContentApiName = 'content';
export const confluenceSummaryApiName = 'summary';
